/* eslint-disable
    func-names,
    max-len,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['$scope', 'Conversation', 'ConversationCollection', 'ConversationSummaryCollection'];

const ConversationCtrl = function (
  $scope,
  Conversation,
  ConversationCollection,
  ConversationSummaryCollection,
) {
  let conversation = new Conversation();

  $scope.$watch('vm.conversationId', () => {
    // fetch existing conversation or create a new conversation with
    // attachedTo
    conversation = new Conversation(this.conversationId);
    this.conversationVM = conversation.$viewModel();

    // used for posting new conversations
    this.conversationCollection = new ConversationCollection(
      `${this.clientId}_${this.attachedTo}`,
      {
        clientId: this.clientId,
        attachedTo: this.attachedTo,
      },
    );

    return (this.conversationSummaryCollection = new ConversationSummaryCollection(
      `${this.clientId}_${this.attachedTo}`,
      {
        clientId: this.clientId,
        attachedTo: this.attachedTo,
      },
    ));
  });

  this.postNewComment = () => {
    let promise;
    if (this.conversationId) {
      promise = conversation.$post(this.conversationVM.newComment);
    } else {
      promise = this.conversationCollection
        .$post(this.conversationVM.newComment)
        .then(res => (this.conversationId = res.data.id));
    }
    return promise.then(res => {
      this.conversationVM.newComment = '';
      return this.conversationSummaryCollection.$fetch();
    });
  };
};

ConversationCtrl.$inject = deps;

module.exports = ConversationCtrl;
